import React, { useEffect } from 'react';
// material-ui


// project imports

import 'react-confirm-alert/src/react-confirm-alert.css';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';
import 'survey-core/modern.css';
import 'survey-core/i18n/turkish';




const ServiceDigitalForms = ({ anketSoru, anketCevap, readonly, onComplete, serviceCodeQuestion, serviceNameQuestion, serviceFullNameQuestion, serviceShopFullName }) => {


    const survey = new Model(anketSoru);
    survey.locale = 'tr';
    survey.onValueChanged.add(function (sender, options) {
        if (options.name === "question32") {
            const secim = sender.getValue("question32")?.["Serviste taşıma kılıfı var mı?Ürünü ambalajsız taşıma zorunluluğu gerektiği durumlarda taşıma kılıfı kullanılıyor mu?\t\t\t\t\t\t"];
            const gorselSoru = sender.getQuestionByName("tasimaKilifiGorsel");

            if (!gorselSoru) return;

            if (secim === "Column 4") {
                // Olumsuz Gözlem seçildiyse → görsel alanını gizle ve zorunluluğu kaldır
                gorselSoru.visible = false;
                gorselSoru.clearValue();
                gorselSoru.isRequired = false;
            } else if (secim) {
                // Diğer herhangi bir seçim yapıldıysa → göster ve zorunlu yap
                gorselSoru.visible = true;
                gorselSoru.isRequired = true;
            }
        }
    });

    survey.mode = readonly ? "display" : "edit"

    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    useEffect(() => {
        const serviceInformation = splitString(serviceShopFullName);
        const serviceCode = serviceInformation.leftPart;
        const serviceName = serviceInformation.rightPart;


        if (serviceCodeQuestion) {
            const serviceCodeQuestionObject = survey.getQuestionByName(serviceCodeQuestion);
            serviceCodeQuestionObject.value = serviceCode;
            serviceCodeQuestionObject.readOnly = true;
        }

        if (serviceNameQuestion) {
            const serviceNameQuestionObject = survey.getQuestionByName(serviceNameQuestion);
            serviceNameQuestionObject.value = serviceName;
            serviceNameQuestionObject.readOnly = true;
        }

        if (serviceFullNameQuestion) {
            const serviceFullNameQuestionObject = survey.getQuestionByName(serviceFullNameQuestion);
            serviceFullNameQuestionObject.value = serviceShopFullName;
            serviceFullNameQuestionObject.readOnly = true;
        }




    }, [survey]);

    function splitString(str) {
        const index = str.indexOf(" ");


        if (index !== -1) {
            const leftPart = str.substring(0, index).trim();
            const rightPart = str.substring(index + 1).trim();
            return { leftPart, rightPart };
        } else {

            return { leftPart: str, rightPart: '' };
        }
    }

    return (
        <div>
            <Survey model={survey}
                data={isJsonString(anketCevap) ? JSON.parse(anketCevap) : anketCevap}
                onComplete={onComplete}
                completeText="Formu Tamamla"
                emptySurvey="Uygun Form Bulunamadı." />
        </div>

    );



};
export default ServiceDigitalForms;